import React from 'react';
export function Footer() {
  return <footer className="bg-polo-navy py-8 md:py-12 border-t border-white/10" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-46">
        <p className="text-gray-400 text-xs md:text-sm mb-2" data-id="element-47">
          © 2026 Polo 360 — RincónDocente360. Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs md:text-sm" data-id="element-48">
          RincónDocente360 · Recursos profesionales para docentes argentinos
        </p>
      </div>
    </footer>;
}